// src/pages/Home.js
import React from 'react';
import Adoptar from '../AdoptarComponents/Adoptar';
function Home() {
  return (
    <div>
      <Adoptar/>
    </div>
  );
}

export default Home;